import * as React from "react";

export const SvgStar = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={45} height={44} fill="none" {...props}>
		<circle cx={22.5} cy={22} r={21.5} fill="#fff" stroke="#FFB11A" />
		<path
			fill="#FFB11A"
			d="M32.448 19.242a1.062 1.062 0 0 0-.915-.73l-5.773-.524-2.282-5.342a1.063 1.063 0 0 0-1.956 0l-2.281 5.342-5.774.524a1.065 1.065 0 0 0-.605 1.86l4.365 3.826-1.287 5.668a1.063 1.063 0 0 0 1.582 1.15l4.978-2.977 4.977 2.976a1.062 1.062 0 0 0 1.583-1.149l-1.287-5.668 4.365-3.826c.32-.281.441-.724.31-1.13Z"
		/>
	</svg>
);
